import {Component, OnInit} from '@angular/core';
import {CaptacionEntity, ServicioCaptacionService} from '../../services/servicio-captacion.service';
import {ActivatedRoute} from '@angular/router';
import {ExcelService} from '../../services/utils/excel.service';
import {EntidadEmpresarialEntity, ServicioEntidadService} from '../../services/servicio-entidad.service';
import {HttpErrorResponse} from '@angular/common/http';
import { ImagesService } from 'src/app/services/utils/images.service';

@Component({
  selector: 'app-reporte-captacion',
  templateUrl: './reporte-captacion.component.html',
  styleUrls: ['./reporte-captacion.component.css']
})
export class ReporteCaptacionComponent implements OnInit {

  captadores: CaptacionEntity[][] = [];

  entidadEmpresarial: EntidadEmpresarialEntity = new class implements EntidadEmpresarialEntity {
    codigoPrestador: string;
    descripcion: string;
    digitoVerificacion: string;
    direccion: string;
    identificacionTributaria: string;
    sede: string;
    telefono: string;
    unco: number;
    urlLogo: string;
  };

  uncoSede: number;

  loading: boolean;

  codeBd: string;
  logo: string;
  user: string;

  fechaImpresion: Date;
  now = new Date();

  constructor(
    private activatedRoute: ActivatedRoute,
    private servicioCaptacionService: ServicioCaptacionService,
    private servicioImagenes: ImagesService,
    private servicioEntidad: ServicioEntidadService,
    private servicioExcel: ExcelService) {
    this.activatedRoute.params.subscribe(params => {
      this.codeBd = params['codigoBaseDatos'];
      this.uncoSede = params['uncoSede'];
      this.user = params['user'];
    });
  }

  async ngOnInit() {
    this.getLogo(this.codeBd);
    this.now = new Date();
  }

  async getLogo(codigoBaseDatos: string) {
    try {
      this.logo = '';
      const response = await this.servicioImagenes.getLogo(codigoBaseDatos);
      if (response != null) {
        response.subscribe((data: any) => {
          this.logo = data.source;
          this.getEntidadEmpresarial();
        }, (err: HttpErrorResponse) => {
          this.logo = '';
          console.error('Error ReporteCaptacion.getLogo():', err);
        })
      }
    } catch(e) {
      this.logo = '';
      console.error('Catch ReporteCaptacion.getLogo():', e);
    }
  }

  async onFiltrosCompletados($event: any) {
    this.loading = true;
    this.now = new Date();
    this.getLogo(this.codeBd);
    this.getData($event);
  }

  async getEntidadEmpresarial() {
    const response = await this.servicioEntidad.getEntidadEmpresarial(this.codeBd, this.uncoSede);
    if (response != null) {
      response.subscribe((data: any) => {
        if (data && Array.isArray(data) && data.length > 0) {
          this.entidadEmpresarial = data[0];
        }
      }, (err: HttpErrorResponse) => {
        console.error('Error entidad Empresarial', err);
      });
    }
  }

  async getData(event: any) {
    const response = await this.servicioCaptacionService.getCaptaciones(this.codeBd, event.fechaInicial, event.fechaFinal);

    if (response != null) {
      response.subscribe((captaciones: CaptacionEntity[]) => {
        const captacionesGroupByCaptador = {};
        this.captadores.length = 0;

        for (const captacion of captaciones) {
          const key: string = captacion.captador;
          if (!Object.keys(captacionesGroupByCaptador).includes(key)) {
            captacionesGroupByCaptador[key] = [];
          }
          captacionesGroupByCaptador[key].push(captacion);
        }

        for (const captacionesGroupByCaptadorKey of Object.keys(captacionesGroupByCaptador)) {
          this.captadores.push(captacionesGroupByCaptador[captacionesGroupByCaptadorKey]);
        }
        this.loading = false;

      }, (err: any) => {
        console.error('Catch ReporteCaptacion.onFiltrosCompletados(): ', err);
        this.loading = false;
      });
    }
  }

  onSumarSaldo(captador: CaptacionEntity[]) {
    let saldo = 0;
    for (const captacionEntity of captador) {
      saldo = saldo + captacionEntity.saldo;
    }
    return saldo;
  }

  onSumarValorRecaudado(captador: CaptacionEntity[]) {
    let saldo = 0;
    for (const captacionEntity of captador) {
      saldo = saldo + captacionEntity.valorRecaudado;
    }
    return saldo;
  }

  onSumarValorServicio(captador: CaptacionEntity[]) {
    let saldo = 0;
    for (const captacionEntity of captador) {
      saldo = saldo + captacionEntity.valorServicios;
    }
    return saldo;
  }

  buildExcel() {

    const captadores = [];

    for (const captador of this.captadores) {
      for (const tmp of captador) {
        captadores.push(tmp);
      }
    }

    const newCaptadores = captadores.map(item => {
      return {
        captador: item.captador,
        fechaCita: item.fecha_cita,
        fechaAsignacion: item.fechaAsignacion,
        identificacion: item.tipo_identificacion_paciente + '-' + item.identificacion_paciente,
        paciente : item.paciente,
        valorServicios : item.valorServicios,
        valorRecaudado : item.valorRecaudado,
        saldo : item.saldo
      };
    });

    this.servicioExcel.exportAsExcelFile(newCaptadores, 'reporte captación', 'reporte captación');
  }
}
